import type { ReactNode } from 'react';
import type { IconNames } from '@workramp/ui';
import { useState } from 'react';
import { Row, Col, IconButton, Span, Icon, Stack } from '@workramp/ui';
import { StyledInnerContainer, StyledDescription } from './CollapsibleSetting.styles';

interface CollapsibleSettingProps {
  children: ReactNode;
  settingName: string;
  iconName?: IconNames;
  isCollapsible?: boolean;
  description?: ReactNode;
}

export const CollapsibleSetting = ({
  settingName,
  iconName,
  description,
  isCollapsible = true,
  children,
}: CollapsibleSettingProps) => {
  const [showSetting, toggleVisibility] = useState(false);
  const settingVisible = showSetting || !isCollapsible;
  return (
    <StyledInnerContainer>
      <Stack size={4}>
        {settingName && (
          <Row align="center" gapX={10} justify="space-between">
            <Col xs="auto">
              <Row align="center" gapX={2}>
                <Col xs="auto">
                  <Icon name={iconName} />
                </Col>
                <Col xs="auto">
                  <Span weight="medium" density="lg">
                    {settingName}
                  </Span>
                </Col>
              </Row>
            </Col>
            {isCollapsible && (
              <Col xs="auto">
                <IconButton
                  color="secondary"
                  iconName={showSetting ? 'caret-down:regular' : 'caret-up:regular'}
                  label={showSetting ? 'Show' : 'Hide'}
                  variant="text"
                  onPress={() => toggleVisibility(!showSetting)}
                />
              </Col>
            )}
          </Row>
        )}

        {settingVisible && (
          <>
            {description && <StyledDescription>{description}</StyledDescription>}
            {children}
          </>
        )}
      </Stack>
    </StyledInnerContainer>
  );
};
